// extracted by mini-css-extract-plugin
export var roundIcon = "Article-module--roundIcon--bnxco";
export var sectionTop = "Article-module--sectionTop--ZE53e";
export var sectionTopContent = "Article-module--sectionTopContent--9ff9r";
export var sectionTopLink = "Article-module--sectionTopLink--Ogu8E";
export var sectionTopNoPadding = "Article-module--sectionTopNoPadding--5bj0Q";